import React from "react";
import { useMyLeaveHeaderBadge } from "./use-header-badge";
import { OcAppBarBadge } from "oc/components";

export const MyLeaveHeaderBadge: React.FC = () => {
  const { handleClick, count } = useMyLeaveHeaderBadge();
  if (count === 0) return null;

  return (
    <OcAppBarBadge
      onClick={handleClick}
      icon="mdi:bag-personal"
      id="my-leave-header-badge"
      badgeId="my-leave-header-badge-count"
      value={count}
    />
  );
};
